import FormattedMessage from 'I18n/components/FormattedMessage';
import { FilterIcon } from 'foundations-assets';
import { Button } from 'foundations-components/transitional/components/Button';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useEffect, useState } from 'react';
import { useSearchParams } from '../../hooks/useSearchParams';
import { useAppliedFilters } from '../hooks/useAppliedFilters';
import { FilterPanel } from './FilterPanel';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function FilterPanelButton() {
  const params = useSearchParams();
  const [open, setOpen] = useState(false);
  const {
    compact
  } = useResponsiveProps({
    compact: {
      xs: true,
      lg: false
    }
  });
  const productType = params.get('PRODUCT_TYPE', {
    allowedValues: ['APP', 'AGENT']
  });
  const appliedFilters = useAppliedFilters();
  const count = appliedFilters.filter(f => f.productType === productType).reduce((acc, f) => acc + f.values.length, 0);

  // Close the filter panel when the product type changes
  useEffect(() => {
    setOpen(false);
  }, [productType]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Tooltip, {
      disabled: !!productType,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.filters.moreFiltersDisabledTooltip"
      }),
      children: /*#__PURE__*/_jsxs(Button, {
        disabled: !productType,
        onClick: () => setOpen(true),
        use: "primary-white",
        children: [/*#__PURE__*/_jsx(IconHolder, {
          icon: FilterIcon,
          padding: "0"
        }), !compact && (count > 0 ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceStorefront.filters.moreFiltersWithCount",
          options: {
            count
          }
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceStorefront.filters.moreFilters"
        }))]
      })
    }), /*#__PURE__*/_jsx(FilterPanel, {
      open: open,
      onClose: () => setOpen(false)
    })]
  });
}